<template>
  <Button
    fsize="f12"
    variant="download_gy"
    radius
    class="l-w-155"
    :class="{ 'is-loading': isProcessing }"
    :disabled="isProcessing"
    @click="getCsv"
  >
    <Icon2 variant="download" :size="12" />
    <span>CSVダウンロード</span>
  </Button>
</template>

<script>
import Button from '@/components/Button';
import Icon2 from '@/components/Icon2';
import { getProjectObservationKeywordsDownload } from '@/api/v2/projects';
import utils from '@/utils';

export default {
  props: ['device', 'from', 'project', 'to'],

  components: {
    Button,
    Icon2
  },

  data() {
    return {
      isProcessing: false
    };
  },

  methods: {
    getCsv() {
      this.isProcessing = true;

      const params = {
        device: this.device,
        from: this.$options.filters.dateText(this.from),
        to: this.$options.filters.dateText(this.to)
      };

      getProjectObservationKeywordsDownload({
        idToken: this.auth.idToken,
        params,
        projectId: this.project.id
      })
        .then(response => {
          const now = this.$options.filters.dateText(
            new Date(),
            'YYYY年MM月DD日'
          );
          const fileName = `検索順位チェック_${now}_${this.project.name}.csv`;
          utils.downloadFile(response.data, fileName);
          this.isProcessing = false;
        })
        .catch(error => {
          this.isProcessing = false;
        });
    }
  }
};
</script>
